import { render, staticRenderFns } from "./FormCouponType.vue?vue&type=template&id=b1fc9c7c&"
import script from "./FormCouponType.vue?vue&type=script&lang=js&"
export * from "./FormCouponType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports